import { ProductListContext } from 'product-list/context/ProductListProvider/ProductListProvider'
import { useContext } from 'react'

export const useProductListContext = () => {
	const context = useContext(ProductListContext)
	if (context == null) {
		throw new Error(
			'useProductListContext must be used within a ProductListProvider'
		)
	}
	return context
}
